import React, { useContext } from "react";
import { AppBar, Toolbar } from "@mui/material";
import styled from "styled-components";
import { AppContext } from "../../../../../../App";

const StyledAppBar: any = styled(AppBar)`
  height: 60px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  background-color:  rgb(17 25 72);  // rgb(13 21 69 / 70%)
  z-index: 10;
  transition: left 0.3s, width 0.3s;
`;

const StyledToolbar: any = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
  height: 100%;
`;

interface SubHeaderProps {
  leftSpacing: number;
  children: React.ReactNode;
  isExpanded?: boolean;
}

const drawerWidth = 320;
const compactWidth = 80;
const topSpacing = 60;
//const isExpanded = false;

const SubHeader: React.FC<SubHeaderProps> = ({ leftSpacing, children}) => {
  const appContextProps: any = useContext(AppContext)
  return (
    <StyledAppBar
      position="fixed"
      sx={{
        top: `${topSpacing}px`,
        left: appContextProps.sideBarOpenStatus ? `${drawerWidth}px` : `${compactWidth}px`,
        width: `calc(100% - ${appContextProps.sideBarOpenStatus ? drawerWidth : compactWidth}px)`,
      }}
    >
      <StyledToolbar>{children}</StyledToolbar>
    </StyledAppBar>
  );
};

export default SubHeader;
